import React from 'react'

export default class IconsMainNavSegments extends React.Component {
    render() {
        let className = 'icons-icon'

        return (
            <svg
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
                className={className}
                style={this.props.style}
            >
                <path
                    d='M6.66667 13.3333C6.66661 13.4572 6.70107 13.5787 6.76619 13.6841C6.83131 13.7895 6.92451 13.8746 7.03533 13.93L8.36867 14.5967C8.47033 14.6475 8.58329 14.6714 8.69683 14.6663C8.81036 14.6612 8.9207 14.6271 9.01735 14.5673C9.11401 14.5075 9.19378 14.424 9.24908 14.3247C9.30438 14.2254 9.33339 14.1137 9.33333 14V9.33333C9.33348 9.00292 9.45631 8.68433 9.678 8.43933L14.4933 3.11333C14.5796 3.01771 14.6364 2.89912 14.6567 2.77192C14.6771 2.64472 14.6601 2.51435 14.6079 2.39658C14.5557 2.27881 14.4706 2.17868 14.3627 2.1083C14.2548 2.03792 14.1288 2.0003 14 2H2C1.87107 2.00005 1.74492 2.03748 1.63683 2.10776C1.52874 2.17804 1.44335 2.27815 1.391 2.39598C1.33865 2.5138 1.32159 2.64427 1.34188 2.77159C1.36217 2.89892 1.41895 3.01762 1.50533 3.11333L6.322 8.43933C6.54369 8.68433 6.66652 9.00292 6.66667 9.33333V13.3333Z'
                    stroke='#646464'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </svg>
        )
    }
}
